// Libs
import createReducer from 'fc-utils/createReducer'
import localStorage from 'fc-storage'
import _get from 'lodash/get'

// Reducers
import featureOperator from './featureOperator'
import { reducers as spatialReducers } from 'fc-spatial'

// Controllers
import assetsCtrl from 'fc-ctrl-assets'
import environmentCtrl from 'fc-ctrl-environment'

// Constants
import { RECEIVE_TOKEN } from 'fc-auth'
import {
  UPDATE_MAP,
  SELECT_FEATURE,
  TOGGLE_HOVER_FEATURE,
  CHANGE_GRID_SIZE,
  CHANGE_GRID_ROTATION,
  CHANGE_GRID_OFFSET,
  TOGGLE_HOVER_POINT,
  CHANGE_BASE_LAYER,
  TOGGLE_PANEL,
  SELECT_JOB_FEATURE,
  SELECT_SOIL_TEST_FILTER,
  TOGGLE_IMAGERY_LAYERS,
  SHOW_PREVIOUS_POINTS,
  SET_USER_STATE_BBOX,
} from './constants'
import {
  SET_SOIL_PROPS_MAP_BLOB_ID,
  PROP_SOIL_PROPS_MAP_BLOB_ID,
} from 'hfty-map-dom/src/constants'
import { SELECT_SOIL_JOB } from 'hfty-soil-jobs-dom/src/constants'
import {
  SELECT_FARM,
  SELECT_FIELD,
} from 'hfty-assets/src/constants'
import { SELECT_SEASON } from 'hfty-seasons'
import {
  PROP_HEFTY_SELECTED_FARM,
  PROP_HEFTY_SELECTED_SEASON,
} from 'fc-model-environment'

// InitialState
import initialState from './initialState'

// Reducer
const mapReducers = {
  ...spatialReducers,
  ...featureOperator.reducers,
  [TOGGLE_PANEL]: (state) => ({
    ...state,
    panelToggled: !state.panelToggled,
  }),
  [UPDATE_MAP]: (state, payload) => ({
    ...state,
    ...payload,
  }),
  [SELECT_FARM]: (state, payload) => ({
    ...state,
    selectedFarmId: Number(payload) || null,
    gridOffset: null,
    selectedFieldId: null,
    selectedFeatureIndex: null,
    hoverFeatureIndex: null,
    selectedJobId: null,
    [PROP_SOIL_PROPS_MAP_BLOB_ID]: null,
  }),
  [SELECT_FIELD]: (state, payload) => ({
    ...state,
    selectedFieldId: Number(payload) || null,
    gridOffset: null,
    selectedFeatureIndex: null,
    hoverFeatureIndex: null,
    selectedJobId: null,
    [PROP_SOIL_PROPS_MAP_BLOB_ID]: null,
  }),
  [SELECT_SEASON]: (state, payload) => ({
    ...state,
    selectedSeasonId: Number(payload) || null,
    selectedFeatureIndex: null,
    hoverFeatureIndex: null,
    selectedFieldId: null,
    selectedJobId: null,
    [PROP_SOIL_PROPS_MAP_BLOB_ID]: null,
  }),
  [CHANGE_GRID_SIZE]: (state, payload) => ({
    ...state,
    gridSize: Number(payload),
  }),
  [CHANGE_GRID_ROTATION]: (state, payload) => ({
    ...state,
    gridRotate: Number(payload),
  }),
  [CHANGE_GRID_OFFSET]: (state, payload) => ({
    ...state,
    gridOffset: payload,
  }),
  [SELECT_FEATURE]: (state, payload) => ({
    ...state,
    selectedFeatureIndex: payload,
  }),
  [TOGGLE_HOVER_FEATURE]: (state, payload) => ({
    ...state,
    hoverFeatureIndex: payload,
  }),
  [TOGGLE_HOVER_POINT]: (state, payload) => ({
    ...state,
    hoverSamplingPoint: payload,
  }),
  [SELECT_SOIL_TEST_FILTER]: (state, payload) => ({
    ...state,
    selectedSoilTestFilter: payload,
  }),
  [CHANGE_BASE_LAYER]: (state, payload) => ({
    ...state,
    mapUrl: payload,
  }),
  [RECEIVE_TOKEN]: (state, payload) => ({
    ...state,
    mapUrl: localStorage.getItem('hfty-map-url') || 'Hybrid',
  }),
  [TOGGLE_IMAGERY_LAYERS]: (state, payload) => ({
    ...state,
    imageryLayerToggled: !state.imageryLayerToggled,
  }),
  [SHOW_PREVIOUS_POINTS]: (state, payload) => ({
    ...state,
    isPreviousPointsShown: payload,
  }),
  [SELECT_SOIL_JOB]: (state, payload) => ({
    ...state,
    selectedJobId: payload,
  }),
  [SELECT_JOB_FEATURE]: (state, payload) => {
    return {
      ...state,
      selectedFeatureIndices: [...payload],
    }
  },
  [SET_USER_STATE_BBOX]: (state, payload) => {
    return {
      ...state,
      centerBbox: payload,
    }
  },
  [assetsCtrl.actionTypes.deleted()]: (state, payload) => {
    if (payload.id === state.selectedFieldId) {
      return {
        ...state,
        selectedFieldId: null,
      }
    }

    return state
  },
  [SET_SOIL_PROPS_MAP_BLOB_ID]: (state, blobId) => ({
    ...state,
    [PROP_SOIL_PROPS_MAP_BLOB_ID]: blobId,
  }),
  [environmentCtrl.actionTypes.receive()]: (state, payload) => {
    const selectedSeason = _get(payload, `data[${PROP_HEFTY_SELECTED_SEASON}]`, {})
    const selectedFarm = _get(payload, `data[${PROP_HEFTY_SELECTED_FARM}]`, {})
    let updates = {}

    if (selectedSeason.value && !state.selectedSeasonId) {
      updates.selectedSeasonId = selectedSeason.value ? Number(selectedSeason.value) : null
    }

    if (selectedFarm.value && !state.selectedFarmId) {
      updates.selectedFarmId = selectedFarm.value ? Number(selectedFarm.value) : null
    }

    return {
      ...state,
      ...updates,
    }
  },
}

// Exports
export default createReducer(initialState, mapReducers)
